// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"96d46aa5","504":"41b1af23","613":"7b42281a"}[chunkId] + ".css";
};